import { Money } from 'types/entity/product';
import Price from './Price';

type Props = {
  price?: Money;
  locale: string;
};

const DiscountedPrice: React.FC<Props> = ({ price, locale }) => {
  return <Price locale={locale} price={price} className="text-accent-red" />;
};

export default DiscountedPrice;
